import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useCallback, useRef, useMemo } from 'react';
import { emptyObject } from './helpers.esm.js';
import { mergeDeepRight } from 'ramda';
import { useForkRef, Modal, ContainerContextProvider } from '@costar/theme-ui';
import { useModalOrchestration } from '../hooks/use-modal-orchestration.esm.js';
import { useSetModalId } from '../hooks/use-set-modal-id.esm.js';
import { useOnEscape } from '../hooks/use-on-escape.esm.js';

var _excluded = ["modalId"],
  _excluded2 = ["children"];
var defaultFodalProps = {
  useModalAsBackdrop: true,
  BackdropProps: {
    variant: 'fodal.backdrop'
  }
};
var FodalBasePrivate = function FodalBasePrivate(_ref) {
  var modalId = _ref.modalId,
    props = _objectWithoutProperties(_ref, _excluded);
  var p = mergeDeepRight(defaultFodalProps, props !== null && props !== void 0 ? props : emptyObject // eslint-disable-next-line @typescript-eslint/no-explicit-any
  );
  var children = p.children,
    rest = _objectWithoutProperties(p, _excluded2);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    container = _useState2[0],
    setContainer = _useState2[1];
  var _useModalOrchestratio = useModalOrchestration(container, modalId),
    last = _useModalOrchestratio.last,
    uid = _useModalOrchestratio.uid;
  useSetModalId(container, uid);
  var onCloseProp = props.onClose;
  var onClose = useCallback(function () {
    return onCloseProp && onCloseProp({}, 'escapeKeyDown');
  }, [onCloseProp]);
  var containerRef = useRef(null);
  var modalRef = useForkRef(function (node) {
    return setContainer(node);
  }, containerRef);
  var context = useMemo(function () {
    return {
      containerRef: containerRef
    };
  }, []);
  useOnEscape(last ? onClose : undefined);
  return /*#__PURE__*/React.createElement(Modal, _extends({}, rest, {
    ref: modalRef,
    variant: 'fodal.modal'
  }), /*#__PURE__*/React.createElement(ContainerContextProvider, {
    value: context
  }, children));
};
var FodalBase = function FodalBase(props) {
  return props.open ? /*#__PURE__*/React.createElement(FodalBasePrivate, props) : null;
};

export { FodalBase };
//# sourceMappingURL=fodal-base.esm.js.map
